export default "__VITE_ASSET__DpOPvxpy__"